// src/utils/formatTimeAgo.js
import { formatDistanceToNow } from 'date-fns';

export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  try {
    return formatDistanceToNow(new Date(dateString), { addSuffix: true });
  } catch {
    return 'Invalid date';
  }
};
